import React, {useEffect, useState} from "react";
import {CheckCircle, RotateCcw, XCircle} from "lucide-react";
import {useApiLmsSaveAnswer} from "@/api/lms";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

const QuizComponent = ({questions, onQuizComplete, setCanContinue, levelDetail}) => {

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedAnswers, setSelectedAnswers] = useState({});
    const [showResults, setShowResults] = useState(false);
    const [score, setScore] = useState(0)

    const {mutate: saveAnswer, isPending, isSuccess} = useApiLmsSaveAnswer()


    const handleAnswerSelect = (questionIndex, answerIndex) => {
        setSelectedAnswers(prev => ({
            ...prev,
            [questionIndex]: answerIndex
        }));
    };

    useEffect(() => {
        if (score > 70) {
            setCanContinue(true)
        } else {
            setCanContinue(false)
        }

    }, [score])

    const calculateScore = () => {
        let correct = 0;
        questions.forEach((question, index) => {
            if (selectedAnswers[index] === question.trueopt) {
                correct++;
            }
        });
        return (correct / questions.length) * 100;
    };

    const calculateAnswerDetail = () => {
        let answerDetail = []
        questions.forEach((question, index) => {
            answerDetail.push({id: question.id, answer: selectedAnswers[index]})
        });
        return answerDetail;
    }

    const handleSubmitQuiz = () => {

        const myScoreCalculated = calculateScore();
        setScore(myScoreCalculated);
        const passed = score >= 70;
        setShowResults(true);
        onQuizComplete(passed, myScoreCalculated);

        saveAnswer({
            id: levelDetail?.data?.data?.id,
            answer: calculateAnswerDetail()
        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }

        })
    };

    if (showResults) {
        const myScoreCl = calculateScore();
        const passed = myScoreCl >= 70;

        return (
            <div className="p-8 text-center">
                <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 ${
                    passed ? 'bg-green-100' : 'bg-red-100'
                }`}>
                    {passed ? (
                        <CheckCircle className="w-12 h-12 text-green-600"/>
                    ) : (
                        <XCircle className="w-12 h-12 text-red-600"/>
                    )}
                </div>

                <h3 className="text-2xl font-bold mb-4  ">
                    {passed ? 'تبریک! شما قبول شدید' : 'متأسفانه قبول نشدید'}
                </h3>

                <p className="text-lg text-gray-600 mb-6">
                    نمره شما: <span className="font-bold">{score.toFixed(0)}%</span>
                </p>

                <div className="flex justify-center gap-4">
                    <button
                        onClick={() => window.location.reload()}
                        className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                    >
                        <RotateCcw size={18}/>
                        تلاش مجدد
                    </button>


                </div>
            </div>
        );
    }

    const question = questions[currentQuestion];
    const options = [question.opt1, question.opt2, question.opt3, question.opt4].filter(Boolean);

    return (
        <div className=" rounded-xl p-8">
            <div className="mb-6">
                <div className="flex justify-between items-center mb-4">
          <span className="text-sm text-gray-500">
            سوال {currentQuestion + 1} از {questions.length}
          </span>
                    <div className="w-32 bg-gray-200 rounded-full h-2">
                        <div
                            className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                            style={{width: `${((currentQuestion + 1) / questions.length) * 100}%`}}
                        />
                    </div>
                </div>

                <h3 className="text-lg font-medium   leading-relaxed">
                    {question.title}
                </h3>
            </div>

            <div className="space-y-3 mb-8">
                {options.map((option, index) => (
                    <button
                        key={index}
                        onClick={() => handleAnswerSelect(currentQuestion, index + 1)}className={`w-full p-4 text-right rounded-lg border-2 transition-all ${
                        selectedAnswers[currentQuestion] === index + 1
                            ? 'border-blue-500 bg-blue-50 text-blue-700 dark:border-blue-400 dark:bg-blue-950/40 dark:text-blue-300'
                            : 'border-gray-200 hover:border-gray-300 dark:border-gray-700 dark:hover:border-gray-500 dark:text-gray-200'
                    }`}
                    >
                        <span className="font-medium">{index + 1}. </span>
                        {option}
                    </button>
                ))}
            </div>

            <div className="flex justify-between">
                <button
                    onClick={() => setCurrentQuestion(prev => Math.max(0, prev - 1))}
                    disabled={currentQuestion === 0}
                    className="px-6 py-2 text-gray-600 hover:  disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    سوال قبلی
                </button>

                {currentQuestion === questions.length - 1 ? (
                    <button
                        onClick={handleSubmitQuiz}
                        disabled={Object.keys(selectedAnswers).length !== questions.length}
                        className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        ارسال آزمون
                    </button>
                ) : (
                    <button
                        onClick={() => setCurrentQuestion(prev => Math.min(questions.length - 1, prev + 1))}
                        disabled={!selectedAnswers[currentQuestion]}
                        className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        سوال بعدی
                    </button>
                )}
            </div>
        </div>
    );
};
export default QuizComponent;